import ArrayBuffer from './ArrayBuffer';
import * as mat4 from './glMatrix/mat4';
import * as mat3 from './glMatrix/mat3';
import * as vec3 from './glMatrix/vec3';

class GeometryBuffer {
	
	constructor(gl, size) {
		if (!gl) {
			return;
		}

		this.gl = gl;
		this.attributes = {}
		this.length = size || 0;
		// this.vertices = [];
		// this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		// this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		// this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		// this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
	}

	addAttribute(attribName, data, size, geometry, type) {
		this.attributes[attribName] = new ArrayBuffer(this.gl, data, size, attribName === 'index', geometry, type);//true=use element array buffer
	}

	getBoundingBox() {
		if (!this.boudingBox) {
			this.computeBoudingBox()
		}
		return this.boudingBox
	}
	computeBoudingBox(origin) {
		let min = vec3.fromValues(100000,100000,100000);
		let max = vec3.fromValues(-100000,-100000,-100000);
		let positions = this.attributes.position.data;
		for (let i=0; i<positions.length; i+=3) {
			if (positions[i+0] < min[0])  min[0] = positions[i+0]
			if (positions[i+0] > max[0])  max[0] = positions[i+0]
			if (positions[i+1] < min[1])  min[1] = positions[i+1]
			if (positions[i+1] > max[1])  max[1] = positions[i+1]
			if (positions[i+2] < min[2])  min[2] = positions[i+2]
			if (positions[i+2] > max[2])  max[2] = positions[i+2]
		}
		let boundingBoxCenter = vec3.create();
		boundingBoxCenter[0] = min[0] + (max[0] + min[0]*-1) * .5
		boundingBoxCenter[1] = min[1] + (max[1] + min[1]*-1) * .5
		boundingBoxCenter[2] = min[2] + (max[2] + min[2]*-1) * .5
		let boudingBoxWidth  = Math.abs(max[0]-boundingBoxCenter[0])*2
		let boudingBoxHeight = Math.abs(max[1]-boundingBoxCenter[1])*2
		let boudingBoxDepth  = Math.abs(max[2]-boundingBoxCenter[2])*2
		this.boudingBox =  {
			center: boundingBoxCenter,
			width:  boudingBoxWidth,
			height: boudingBoxHeight,
			depth:  boudingBoxDepth,
			aabb: [
				min[0],min[1],min[2],
				max[0],max[1],max[2]
			]
		}
	}
	getBoundingSphere() {
		let minX = 100000;
		let minY = 100000;
		let minZ = 100000;
		let maxX = -100000;
		let maxY = -100000;
		let maxZ = -100000;
		let positions = this.attributes.position.data;
		for (let i=0; i<positions.length; i+=3) {
			if (positions[i+0] < minX)  minX = positions[i+0]
			if (positions[i+0] > maxX)  maxX = positions[i+0]
			if (positions[i+1] < minY)  minY = positions[i+1]
			if (positions[i+1] > maxY)  maxY = positions[i+1]
			if (positions[i+2] < minZ)  minZ = positions[i+2]
			if (positions[i+2] > maxZ)  maxZ = positions[i+2]
		}
		let boundingSphereCenter = vec3.create();
		boundingSphereCenter[0] = minX + (maxX + minX*-1) * .5
		boundingSphereCenter[1] = minY + (maxY + minY*-1) * .5
		boundingSphereCenter[2] = minZ + (maxZ + minZ*-1) * .5
		let boudingSphereRadius = 0;
		let p = vec3.create()
		for (let i=0; i<positions.length; i+=3) {
			vec3.set(p, positions[i+0], positions[i+1], positions[i+2]);
			vec3.subtract( p, p, boundingSphereCenter );
			boudingSphereRadius = Math.max( boudingSphereRadius, (vec3.length(p)) )
		}
		return {
			center: boundingSphereCenter,
			radius: boudingSphereRadius,
		}
	}

}


export default GeometryBuffer;